module.exports = __webpack_public_path__ + "static/1342042952.d0a691e1.jpg";